export default "__VITE_ASSET__D_nEbF3T__"